document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.disclosure-list__option[data-value]').forEach(option => {
      option.addEventListener('click', function(event) {
        event.preventDefault(); // Stop the link from directing immediately.
  
        // Extract the selected currency code.
        const currencyCode = this.getAttribute('data-value');
  
        // Find the Shopify form used for currency change submissions.
        const form = document.querySelector('.site-header__currency-form');
        if (form) {
          // Update the value of the hidden input that Shopify uses to detect currency changes.
          const input = form.querySelector('input[name="country_code"]');
          if (input) {
            input.value = currencyCode;
          }
  
          // Programmatically submit the form to trigger the currency change.
          form.submit();
        }
      });
    });
  
    // Close the dropdown when clicking outside
    const dropdownList = document.getElementById('country-list');
    const toggleButton = document.querySelector('.disclosure__toggle');
  
    document.addEventListener('click', function(event) {
      if (dropdownList && !dropdownList.contains(event.target) && !toggleButton.contains(event.target)) {
        dropdownList.style.display = 'none';
      }
    });
  
    // Optional: Toggle the dropdown's visibility upon clicking the button.
    if (toggleButton) {
      toggleButton.addEventListener('click', function(event) {
        event.stopPropagation();
        dropdownList.style.display = dropdownList.style.display === 'block' ? 'none' : 'block';
      });
    }
  });
  